import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { UIVariant } from '@gik/ui/types';
import { Heading } from '@gik/ui';

export interface IFeatureContent {
  variant?: UIVariant | 'danger' | 'success' | 'blue' | 'warn';
  title?: React.ReactNode;
  aside?: React.ReactNode;
  description?: React.ReactNode;
  reversed?: boolean;
  titleCentered?: boolean;
  headingLevel?: 2 | 3;
}

export type IFeatureContentProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & IFeatureContent;

export default function FeatureContent({
  variant = 'primary',
  children,
  className,
  title,
  description,
  reversed,
  aside,
  titleCentered,
  headingLevel = 3,
  ...otherProps
}: IFeatureContentProps): React.ReactElement {
  const bem = bemBlock('feature-content');
  const blockClasses = bem(
    null,
    [{ [variant]: variant }, { reversed }, { 'title-centered': titleCentered }],
    className
  );

  const asideWrapper = aside ? <aside>{aside}</aside> : null;

  return (
    <section className={blockClasses} {...otherProps}>
      {reversed && asideWrapper}
      <main>
        {title && (
          <Heading level={headingLevel} noStyling className={bem('title', null, `tw-text-${variant}-500`)}>
            {title}
          </Heading>
        )}
        {description && <div className={bem('description')}>{description}</div>}
        {children}
      </main>
      {!reversed && asideWrapper}
    </section>
  );
}
